<div *ngIf="uplBannerEnabled && uplBanner" class="loanContainer">
  <div id="loanBanner" class="row">
    <div>
      <div class="loanDetails">
        <div class="loanHeader">{{ uplBanner.header }}</div>
        <div class="loanText">{{ uplBanner.text }}</div>
      </div>
      <div class="btnContainer">
        <button
          class="btn btn-secondary pull-right"
          type="button"
          data-test-id="button-findoutmore"
          (click)="goToLink(uplBanner.url)"
          [attr.aria-label]="
            'FIND OUT MORE about ' + brand + ' loans opens in new tab'
          "
        >
          FIND OUT MORE
        </button>
      </div>
    </div>
  </div>
</div>
